<template lang="pug">
  .d-flex.col-12.p-0(v-if="currentUser.rights.monitoring == true")
    .col-8.p-0
      .monitoring.mr-5.px-0.align-items-stretch
        .d-flex.content-wrapper.justify-content-between.col-12.mb-5
          h2.col-3.m-0.p-0 Операторы
          button(v-bind:class="['btn', 'btn-outline-success', 'col-2', {'active': this.selectedFilters.includes('income')}]" v-on:click="toggleFilters('income')") Входящий: {{incomeCount}}
          button(v-bind:class="['btn', 'btn-outline-primary', 'col-2', {'active': this.selectedFilters.includes('outcome')}]" v-on:click="toggleFilters('outcome')") Исходящий: {{outcomeCount}}
          button(v-bind:class="['btn', 'btn-outline-warning', 'col-2', {'active': this.selectedFilters.includes('active')}]"  v-on:click="toggleFilters('active')") Ожидает: {{activeCount}}
          button(v-bind:class="['btn', 'btn-outline-danger', 'col-2', {'active': this.selectedFilters.includes('online')}]" v-on:click="toggleFilters('online')") Неактивен: {{onlineCount}}
        .row.flex-wrap(v-if="filteredCards.length > 0")
          .col-4(v-for="op in filteredCards" :key="op.key")
            div(v-bind:class="['content-wrapper','w-100', {'d-none': op.status=='offline'}]")
              .d-flex.justify-content-between.dropdown-settings
                .col-10.p-0
                  p.font-weight-bold
                    i(v-bind:class="['far','fa-circle', 'font-weight-bold', {'text-primary': op.direction=='1', 'text-success': op.direction=='0', 'text-danger': op.status=='online', 'text-warning': op.status=='active'}]") &nbsp;
                    | {{op.name}} &nbsp;
                    span.font-weight-normal ({{op.innerphone}})
                  .mt-1(v-if="op.status=='income' || op.status=='outcome'")
                    .mt-3 {{op.project}}
                    .mt-1(v-if="op.status=='outcome' && op.direction=='1'")
                      i.far.fa-arrow-from-left.font-weight-bold {{op.phone}}
                    .mt-1(v-if="op.status=='income' && op.direction=='0'")
                      i.far.fa-arrow-to-left.font-weight-bold {{op.phone}}
                    .mt-1(v-if="op.postprocessing=='1'")
                      span.font-weight-bold Постобработка &nbsp;
                    .mt-1(v-else)
                      i.far.fa-clock.mr-2
                      span.font-weight-bold {{ seconds2time( op.timer ) }}
                  .mt-3.mr-2(v-if="op.status=='active'") Ожидается вызов &nbsp;
                    i.far.fa-clock.mr-2
                    span.font-weight-bold  {{seconds2time(op.timer)}}
                  .mt-3.mr-2(v-if="op.status=='online'") Неактивен &nbsp;
                    i.far.fa-clock.mr-2
                    span.font-weight-bold {{seconds2time(op.timer)}}
                .col-1.p-0
                  i.far.fa-cog(v-on:click='op.isMenuVisible=!op.isMenuVisible')
                  div(v-show="op.isMenuVisible")
                    i.far.fa-check(v-on:click="changeState('start', op.id)")
                    i.far.fa-times(v-on:click="changeState('stop', op.id)")
        .d-flex.content-wrapper-transparent.graph-container.col-12.align-items-center.justify-content-center(v-else)
          h2 В данный момент нет доступных операторов
    .monitoring.col-4.content-wrapper
        h2.col-12.mb-3 Звонки
        div(v-if="filtredCalls.length > 0")
          div(v-for="call in filtredCalls" v-bind:key="call.id" v-bind:class="['d-flex','col-12', 'p-2', 'small', 'mb-2', 'border-bottom', {'d-none': call.status == 'deleted'}]")
            i(v-bind:class="['fas','fa-circle', 'align-self-center', 'font-weight-bold', 'mr-2', {'text-primary': call.status == 'answered' && call.direction == '1', 'text-success': call.status == 'answered' &&  call.direction == '0', 'text-warning': call.status == 'ringing', 'text-danger': call.status == 'completed'}]")
            i.far.fa-clock.align-self-center.mr-1(v-if="call.status == 'ringing'")  {{call.waiting}}
            i.far.fa-clock.align-self-center.mr-1(v-if="call.status == 'answered'")  {{call.speaking}}
            .mx-2.align-self-center
              i.far.fa-arrow-to-left(v-if="call.direction == 0")  {{call.src_number}}
              i.far.fa-arrow-from-left(v-else-if="call.direction == 1") {{call.dst_number}}
            div.align-self-center(v-if="!!call.operator_name") {{call.operator_name}}
            .mx-2.font-weight-bold.col-6 {{call.project_name}}
        .d-flex.graph-container.align-items-center.justify-content-center(v-else)
          p Нет звонков
  .alert.alert-warning.alert-dismissible.fade.show(v-else role="alert")
    <strong>Внимание!</strong> У Вас нет прав доступа в этот раздел.
    button.close(type="button" data-dismiss="alert" aria-label="Close")
      span(aria-hidden="true") &times;
</template>
<script>
export default {
  data () {
    return {
      isActive: false,
      connection: null,
      operatorsList: [],
      projectsList: [],
      callsQueue: null,
      cardsList: [],
      selectedFilters: []
    }
  },
  computed: {
    systemSettings: function () {
      return this.$store.getters.system_settings
    },
    filteredCards: function () {
      var cardsList = this.cardsList
      var selectedFilters = this.selectedFilters
      if (selectedFilters != '') {
        cardsList = cardsList.filter(item => selectedFilters.includes(item.status))
      }
      return cardsList.filter(item => item.status !== 'offline')
    },
    filtredCalls: function () {
      // console.log(this.callsQueue)
      if (this.callsQueue === null) {
        return []
      }
      return this.callsQueue
    },
    incomeCount: function () {
      return this.cardsList.filter(item => (item.status == 'income' && item.direction == '0')).length
    },
    outcomeCount: function () {
      return this.cardsList.filter(item => (item.status == 'outcome' && item.direction == '1')).length
    },
    activeCount: function () {
      return this.cardsList.filter(item => item.status == 'active').length
    },
    onlineCount: function () {
      return this.cardsList.filter(item => item.status == 'online').length
    },

    currentUser: function () {
      return this.$store.getters.user
    },
    currentClient: function () {
      return this.$store.getters.client_id
    },
    alertState: {
      get: function () {
        return this.$store.getters.alertState
      },
      set: function (newValue) {
        this.$store.commit('setAlertState', newValue)
      }
    }
  },
  methods: {
    seconds2time: function (seconds) {
      var hours = Math.floor(seconds / 3600)
      var minutes = Math.floor((seconds - (hours * 3600)) / 60)
      seconds = seconds - (hours * 3600) - (minutes * 60)
      var time = ''

      if (hours !== 0) {
        time = hours + ':'
      }
      if (minutes !== 0 || time !== '') {
        minutes = (minutes < 10 && time !== '') ? '0' + minutes : String(minutes)
        time += minutes + ':'
      }
      if (time === '') {
        time = '0:' + seconds
      } else {
        time += (seconds < 10) ? '0' + seconds : String(seconds)
      }
      return time
    },
    // рассчитывает таймеры по всем звонкам
    timer: function () {
      this.callsQueue.forEach(element => {
        if (element.status == "ringing") {
          var callDate = new Date(element.calldate)
          element.waiting = this.seconds2time(Math.round((Date.now() - callDate.getTime()) / 1000))
        }
        if (element.status == "answered") {
          callDate = new Date(element.calldate)
          var a = element.waiting.split(':')
          var seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2])
          element.speaking = this.seconds2time(Math.round((Date.now() - callDate.getTime()) / 1000) - seconds)
        }
      })
      this.cardsList.forEach(element => {
        element.timer++
      })
    },
    initTimer: function () {
      setInterval(this.timer, 1000)
    },
    // запуск таймера
    toggleFilters: function (status) {
      var index = this.selectedFilters.indexOf(status)
      if (index > -1) {
        this.selectedFilters.splice(index, 1)
      } else {
        this.selectedFilters.push(status)
      }
    },
    getItemByID: function (list, id) {
      var item = list.filter(i => i.id == id)
      if (item.length > 0) {
        return item[0]
      }
      return false
    },
    getOperatorByID: function (id) {
      var op = this.getItemByID(this.operatorsList, id)
      if (op === false) {
        // в будущем сделаем дполнительный метод, который будет пытаться с сервера получить данные по пользователю
        op = {actions: "", client_id: "0", email: "", hash: "", id: id, name: "Нет оператора", password: "не скажу", phone: "", reg_date: "", role_id: 0, sip: "00000"}
      }
      return op
    },
    getProjectByID: function (id) {
      return this.getItemByID(this.projectsList, id)
    },
    getCardByID: function (id, project_id = 0) {
      var card = this.getItemByID(this.cardsList, id)
      if (card === false) {
        var operator = this.getOperatorByID(id)
        var project = this.getProjectByID(project_id)
        card = {id: id, name: operator.name, innerphone: operator.sip, project: project.name, status: 'online', isWorking: 0, postprocessing: 0, isMenuVisible: false, duration: 0, timer: 0}
        this.cardsList.push(card)
      }
      return card
    },
    getCallByID: function (id, wsd = false) {
      var call = this.getItemByID(this.callsQueue, id)
      if (call === false) {
        var project = this.getProjectByID(wsd.Project_id)
        call = {
          direction: wsd.Direction,
          op_name: '',
          proj_name: project.name,
          number: wsd.Phone,
          op_id: wsd.Operator_id,
          status: "ringing",
          id: wsd.Call_id,
          duration: 0
        }
        this.callsQueue.push(call)
      }
      return call
    },
    stateOnline: function () {
      this.setConnection()
    },
    wsOnMessage: function (event) {
      var data = JSON.parse(event.data)
      console.log(data)
      var wsd = data.Data
      // console.log(wsd)
      if (wsd != '') {
        wsd = JSON.parse(wsd)
      }
      switch (data.Action) {
        case 'addCall':
          this.wsAddCall(data, wsd)
          break
        case 'endCall':
          this.wsEndCall(wsd)
          break
        case 'operatorAnswerCall':
          this.wsOperatorAnswerCall(wsd)
          break
        case 'operatorSubmitForm':
          wsd.Operator_id = data.User_id
          this.wsOperatorSubmitForm(wsd)
          break
        case 'operatorStartWorking':
          this.wsOperatorStartWorking(wsd)
          break
        case 'operatorStopWorking':
          this.wsOperatorStopWorking(wsd)
          break
        case 'operatorEntryCallPage':
          this.wsOperatorEntryCallPage(wsd)
          break
        case 'operatorLeaveCallPage':
          this.wsOperatorLeaveCallPage(wsd)
          break
        default:
      }
    },
    wsAddCall: function (data, wsd) {
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getCallMonitoringById&id=' + wsd.Call_id)
        .then(response => (this.callsQueue.push(response.data.data)))
    },
    wsEndCall: function (data) {
      var card = this.getCardByID(data.Operator_id, data.Project_id)
      card.postprocessing = 1
      var call = this.getCallByID(data.Call_id, data)
      call.status = "completed"
    },
    wsOperatorAnswerCall: function (data) {
      var card = this.getCardByID(data.Operator_id, data.Project_id)
      var project = this.getProjectByID(data.Project_id)
      card.status = 'income'
      card.direction = 0
      card.postprocessing = 0
      card.phone = data.Phone
      card.project = project.name
      var call = this.getCallByID(data.Call_id, data)
      call.status = "answered"
      var operator = this.getOperatorByID(data.Operator_id)
      call.op_name = operator.name
    },
    wsOperatorSubmitForm: function (data) {
      var card = this.getCardByID(data.Operator_id, data.Project_id)
      card.postprocessing = 0
      if (card.isWorking) {
        card.status = 'active'
      } else {
        card.status = 'online'
      }
    },
    wsOperatorStartWorking: function (data) {
      var card = this.getCardByID(data.Operator_id, data.Project_id)
      card.status = 'active'
      card.timer = 0
      card.isWorking = 1
    },
    wsOperatorStopWorking: function (data) {
      var card = this.getCardByID(data.Operator_id, data.Project_id)
      card.isWorking = 0
      card.status = 'online'
      card.timer = 0
    },
    wsOperatorEntryCallPage: function (data) {
      var card = this.getCardByID(data.Operator_id, data.Project_id)
      card.status = 'online'
      card.timer = 0
    },
    wsOperatorLeaveCallPage: function (data) {
      var card = this.getCardByID(data.Operator_id)
      card.status = 'offline'
    },
    setConnection: function () {
      this.connection = new WebSocket(this.systemSettings.websocket_host)
      this.connection.onopen = () => this.sendDataToWebSocket('connectUser', {Page: "monitoring"})
      this.connection.onmessage = this.wsOnMessage
      this.connection.onerror = (event) => {
        console.error("WebSocket error observed:", event)
        this.alertState.active = true
        this.alertState.message = 'Потеряно соединение с сервером, обновите страницу'
      }
      this.connection.onclose = (event) => console.warn("WebSocket close:", event)
    },
    changeState: function (mark, id) {
      if (mark == "start") {
        this.sendDataToWebSocket('operatorStartWorking', {type: "incomming", Operator_id: id})
      } else {
        this.sendDataToWebSocket('operatorStopWorking', {Operator_id: id})
      }
    },
    sendDataToWebSocket: function (action, data) {
      if (typeof data == 'object') {
        // console.log('data is object')
        data = JSON.stringify(data)
      }
      var wsd = { // WebSocketData
        Action: action, // Событие
        Data: data, // Данные события json объект строкой
        User_id: this.currentUser.id, // id пользователя, который отправляет, если из сервера, то 0
        Client_id: this.currentUser.client_id, // id Клиента, который отправляет (принадлежность юзера клиенту)
        Token: this.currentUser.token // Токен пользователя для проверки авторизации
      }
      // console.log(wsd)
      var msg = JSON.stringify(wsd)
      var lenbyte = encodeURI(msg).split(/%..|./).length - 1
      var len = '' + lenbyte
      while (len.length < 5) {
        len += ' '
      }
      this.connection.send(len + msg)
    }
  },
  mounted () {
    this.setConnection()
    this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getMonitoring')
      .then(response => {
        this.operatorsList = response.data.users
        this.projectsList = response.data.projects
        this.callsQueue = response.data.data
        console.log(this.callsQueue)
        this.operatorsList.forEach(element => {
          var operator = this.getOperatorByID(element.id)
          if (operator.status == null || operator.status == 'offline') {
            return true
          }
          // console.log(element)
          var project = this.getProjectByID(element.project_id)
          var DateChange = new Date(element.date_change)
          // console.log(Math.round((Date.now() - DateChange.getTime()) / 1000))
          var timer = Math.round((Date.now() - DateChange.getTime()) / 1000)
          var card = {id: element.id, name: operator.name, innerphone: operator.sip, project: project.name, status: operator.status, isWorking: 0, postprocessing: 0, isMenuVisible: false, duration: 0, timer: timer}
          this.cardsList.push(card)
        })
        this.initTimer()
        console.log(this.currentUser)
      })
  },
  beforeDestroy () {
    this.connection.close()
    // console.log('close monitoring page')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/monitoring.vue